export function clearLocalData() {
  localStorage.clear();
  sessionStorage.clear();

  if (indexedDB.databases) {
    indexedDB.databases().then((databases) => {
      databases.forEach((dbInfo) => {
        if (dbInfo.name) {
          indexedDB.deleteDatabase(dbInfo.name);
        }
      });
    });
  }
}
